import React from 'react';
import ConversionesTablePage from '../components/ConversionesTablePage';
import { formatDateTime } from '../../../styles/tokens/formatters';
import { baseColors, yoolBrand } from '../../../styles/tokens/colors';

const FUNNEL_STEPS = [
  { key: 'is_simulacion', label: 'Simulación' },
  { key: 'is_cotizacion', label: 'Cotización' },
  { key: 'is_contratacion', label: 'Contratación' },
  { key: 'is_suscripcion', label: 'Suscripción' },
  { key: 'is_certificado', label: 'Certificado' },
];

const ACTIVE_COLOR = baseColors.blue900;   // #1E3A8A — azul marino — en progreso
const DONE_COLOR   = baseColors.green500;  // #22C55E — verde — proceso completo
const INACTIVE_COLOR = yoolBrand.border;   // #E0E0E0 Yool v5.2 — inactivo

const FunnelProgress = ({ row }) => {
  let lastActive = -1;
  FUNNEL_STEPS.forEach((step, i) => {
    if (row?.[step.key]) lastActive = i;
  });

  const isComplete = lastActive === FUNNEL_STEPS.length - 1;

  return (
    <div className="flex items-center gap-2">
      {FUNNEL_STEPS.map((step, i) => {
        const reached = i <= lastActive;
        const isCurrent = i === lastActive && !isComplete;
        return (
          <React.Fragment key={step.key}>
            <div className="flex flex-col items-center gap-1.5">
              <div
                className="rounded-full transition-all"
                style={{
                  width: isCurrent ? '10px' : '8px',
                  height: isCurrent ? '10px' : '8px',
                  backgroundColor: reached
                    ? isComplete ? DONE_COLOR : isCurrent ? ACTIVE_COLOR : `${ACTIVE_COLOR}99`
                    : INACTIVE_COLOR,
                  boxShadow: isCurrent ? `0 0 0 3px ${ACTIVE_COLOR}33` : 'none',
                }}
              />
              <span
                className="text-[9px] leading-none font-medium"
                style={{ color: reached ? (isComplete ? DONE_COLOR : ACTIVE_COLOR) : yoolBrand.textMuted }}
              >
                {step.label}
              </span>
            </div>
            {i < FUNNEL_STEPS.length - 1 && (
              <div
                className="mb-4 rounded-full"
                style={{
                  height: '1.5px',
                  width: '24px',
                  backgroundColor: i < lastActive ? (isComplete ? DONE_COLOR : ACTIVE_COLOR) : INACTIVE_COLOR,
                  opacity: i < lastActive ? 0.6 : 0.4,
                }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

const ConversionesSesiones = () => {
  return (
    <ConversionesTablePage
      title="Conversiones - Sesiones"
      viewName="sesiones_funnel"
      selectFields="id,created_at,canal,ip,user_agent,is_simulacion,is_cotizacion,is_contratacion,is_suscripcion,is_certificado"
      defaultSortKey="created_at"
      defaultSortDirection="desc"
      columns={[
        { key: 'created_at', header: 'Fecha', render: (r) => formatDateTime(r?.created_at) },
        { key: 'canal', header: 'Canal' },
        { key: 'ip', header: 'IP' },
        {
          key: 'funnel',
          header: 'Progreso',
          sortable: false,
          headerClassName: 'w-[560px]',
          cellClassName: 'w-[560px]',
          render: (r) => <FunnelProgress row={r} />
        },
        { key: 'user_agent', header: 'User Agent', render: (r) => r?.user_agent || 'N/A' }
      ]}
    />
  );
};

export default ConversionesSesiones;

